import React, { useEffect, useState } from 'react';
import './styles';
import UIListInputRow from '../../../../../components/UI/UIListInputRow';
import UIDropdownSelect from '../../../../../components/UI/UIDropdownSelect';
import { toast } from 'react-toastify';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import Queries from '../../../../../utils/API/Queries';
import { GET_LISTING_MATTERPORT } from './queries';

export default function ListingMatterports({ listingId }: ListingMatterportsProps) {
	const [listing, setListing] = useState<ListingType>();
	const [matterportModelId, setMatterportModelId] = useState<string>();
	const [selectedPage, setSelectedPage] = useState<PLTab>();
	const [isUpdatingMatterportLink, setIsUpdatingMatterportLink] = useState<boolean>();
	const [updateListing] = useMutation(Queries.UPDATE_LISTING);

	const getPageTabs = (listing): PLTab[] => {
		if (listing && listing.matterportModelId) {
			return [TABS.MANAGE, TABS.ADD_MATTERPORT];
		} else {
			return [TABS.ADD_MATTERPORT];
		}
	};

	const [getListing, { data: listingData }] = useLazyQuery(GET_LISTING_MATTERPORT, {
		variables: { id: listingId }
	});

	useEffect(() => {
		(async () => {
			await getListing();
		})();
	}, []);

	useEffect(() => {
		if (listingData) {
			const fetchedListing: ListingType = listingData['listing'];
			setListing(fetchedListing);
			setMatterportModelId(fetchedListing.matterportModelId);
			setSelectedPage(getPageTabs(fetchedListing)[0]);
		}
	}, [listingData]);

	const updateListingApi = async (key: string, value: any) => {
		let variables = {
			id: listingId,
			[key]: value
		};
		const response = await updateListing({ variables });
		const { updateListing: updatedListing } = response['data'];
		if (updatedListing) {
			await getListing();
		}
	};
	const TABS = {
		MANAGE: { value: 'manage', text: 'View your Matterport' },
		ADD_MATTERPORT: { value: 'addMatterport', text: 'Manage Matterport' }
	};

	if (!listing || !selectedPage) return null;

	const onSaveMatterport = async () => {
		setIsUpdatingMatterportLink(true);
		await updateListingApi('matterportModelId', matterportModelId);
		setIsUpdatingMatterportLink(false);
		setSelectedPage(getPageTabs(listing)[0]);
		if (matterportModelId) {
			toast.success('Matterport successfully added!');
		} else {
			toast.info('Matterport removed!');
		}
	};

	const renderSelectedPage = () => {
		switch (selectedPage.value) {
			case TABS.ADD_MATTERPORT.value:
				return (
					<UIListInputRow
						label={'Add a link to your matterport'}
						placeholder={'Matterport link or Model ID...'}
						value={matterportModelId}
						savedValue={listing.matterportModelId}
						isLoading={isUpdatingMatterportLink}
						onSave={onSaveMatterport}
						style={{ maxWidth: 360 }}
						containerStyle={{ marginLeft: 12 }}
						onChangeValue={setMatterportModelId}
					/>
				);
			case TABS.MANAGE.value:
				return (
					<div className='listingMatterports--page'>
						<iframe
							key={listing.matterportModelId}
							src={`https://my.matterport.com/show/?m=${listing.matterportModelId}`}
							allowFullScreen
							className='listingMatterports__content--matterport'
						/>
					</div>
				);
			default:
				return null;
		}
	};

	return (
		<div className='listingMatterports'>
			<UIDropdownSelect containerClassName='listingMatterports--tabs' selectedTab={selectedPage} updateSelected={setSelectedPage} tabs={getPageTabs(listing)} />
			{renderSelectedPage()}
		</div>
	);
}
